
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StatusReportSection extends Vue {
  @Prop({ default: '' }) readonly previewBody!: string;

  @Prop({ default: false }) readonly isSending!: boolean;

  @Prop({ default: false }) readonly disabled!: boolean;
}
